var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallerynew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.141 55.3109H45.5078C42.9945 55.3109 40.957 57.3407 40.957 59.8446V125.13C40.957 127.633 42.9945 129.663 45.5078 129.663H120.141C122.654 129.663 124.691 127.633 124.691 125.13V59.8446C124.691 57.3407 122.654 55.3109 120.141 55.3109Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.164 55.3109H130.152C127.639 55.3109 125.602 57.3407 125.602 59.8446V125.13C125.602 127.633 127.639 129.663 130.152 129.663H140.164C142.677 129.663 144.715 127.633 144.715 125.13V59.8446C144.715 57.3407 142.677 55.3109 140.164 55.3109Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.188 55.3109H150.176C147.662 55.3109 145.625 57.3407 145.625 59.8446V125.13C145.625 127.633 147.662 129.663 150.176 129.663H160.188C162.701 129.663 164.738 127.633 164.738 125.13V59.8446C164.738 57.3407 162.701 55.3109 160.188 55.3109Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.211 55.3109H170.199C167.686 55.3109 165.648 57.3407 165.648 59.8446V125.13C165.648 127.633 167.686 129.663 170.199 129.663H180.211C182.724 129.663 184.762 127.633 184.762 125.13V59.8446C184.762 57.3407 182.724 55.3109 180.211 55.3109Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.59 61.658H50.0586C48.5506 61.658 47.3281 62.8759 47.3281 64.3782V120.596C47.3281 122.098 48.5506 123.316 50.0586 123.316H115.59C117.098 123.316 118.32 122.098 118.32 120.596V64.3782C118.32 62.8759 117.098 61.658 115.59 61.658Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.129 67.0984H55.5195C54.0115 67.0984 52.7891 68.3163 52.7891 69.8187V116.062C52.7891 117.565 54.0115 118.782 55.5195 118.782H110.129C111.637 118.782 112.859 117.565 112.859 116.062V69.8187C112.859 68.3163 111.637 67.0984 110.129 67.0984Z",
    fill: "#718095"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.074 29.0156H91.0156C89.5076 29.0156 88.2852 30.2334 88.2852 31.7358C88.2852 33.2381 89.5076 34.456 91.0156 34.456H141.074C142.582 34.456 143.805 33.2381 143.805 31.7358C143.805 30.2334 142.582 29.0156 141.074 29.0156Z",
    fill: "#D1D5DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.648 37.1761H67.3516C66.8489 37.1761 66.4414 37.5821 66.4414 38.0829C66.4414 38.5837 66.8489 38.9896 67.3516 38.9896H165.648C166.151 38.9896 166.559 38.5837 166.559 38.0829C166.559 37.5821 166.151 37.1761 165.648 37.1761Z",
    fill: "#3C4148"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.086 39.8964H79.1836C78.6809 39.8964 78.2734 40.3023 78.2734 40.8031C78.2734 41.3039 78.6809 41.7098 79.1836 41.7098H151.086C151.589 41.7098 151.996 41.3039 151.996 40.8031C151.996 40.3023 151.589 39.8964 151.086 39.8964Z",
    fill: "#3C4148"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallerynew);
export default __webpack_public_path__ + "static/media/gallerynew.37d042f4a69568a58e58ea6ca862c6f4.svg";
export { ForwardRef as ReactComponent };